/** @format */

import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { options } from "utils/constant.data";
import { useUpdateFellowProfileMutation } from "store/services/adminAPI";
import {
  extractErrorMessage,
  LearningModeOptions,
  LearningStyleOptions,
  Motivations,
  replaceUnderscoresWithSpaces,
} from "utils/strings";

const Learning = ({ currentProfile, setActiveTab }) => {
  const [updateFellowProfile, { isLoading: updating }] =
    useUpdateFellowProfileMutation();

  // const handleSubmit = async (values) => {
  //   await updateFellowProfile({
  //     ...values,
  //   })
  //     .unwrap()
  //     .then((data) => {
  //       const message = `✔️ Profile updated !`;
  //       toast.success(message, {
  //         position: "top-right",
  //         autoClose: 2500,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //       });
  //       setActiveTab("accessibility");
  //     })
  //     .catch((error) => {
  //       const formattedError = extractErrorMessage(error);
  //       Swal.fire({
  //         title:
  //           replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
  //         text: formattedError,
  //         iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
  //         showCloseButton: true,
  //         customClass: {
  //           icon: "no-border",
  //         },
  //         confirmButtonText: "Try Again",
  //       });
  //     });
  //   // }
  // };
  const handleSubmit = async (values) => {
    // Remove fields that are empty, null, or undefined
    const filteredValues = Object.fromEntries(
      Object.entries(values).filter(
        ([, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    await updateFellowProfile(filteredValues)
      .unwrap()
      .then(() => {
        toast.success("✔️ Profile updated !", {
          position: "top-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
        });
        setActiveTab("accessibility");
      })
      .catch((error) => {
        const formattedError = extractErrorMessage(error);
        Swal.fire({
          title:
            replaceUnderscoresWithSpaces(error?.data?.code) || "Error Occured",
          text: formattedError,
          iconHtml: `<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
          showCloseButton: true,
          customClass: { icon: "no-border" },
          confirmButtonText: "Try Again",
        });
      });
  };



  const formik = useFormik({
    initialValues: {
      preferred_learning_style: currentProfile?.preferred_learning_style,
      preferred_learning_mode: currentProfile?.preferred_learning_mode,
      is_comfortable_with_project_based_learning:
        currentProfile?.is_comfortable_with_project_based_learning,
      primary_motivations_for_participation:
        currentProfile?.primary_motivations_for_participation,
      what_do_you_hope_to_achieve_by_the_end_of_the_program:
        currentProfile?.what_do_you_hope_to_achieve_by_the_end_of_the_program,
      what_topics_or_skills_are_you_most_excited_to_learn_about:
        currentProfile?.what_topics_or_skills_are_you_most_excited_to_learn_about,
    },
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validationSchema: FormSchema,
  });


  return (
    <div className="basic-form">
      <h5>Learning Preferences</h5>

      <form onSubmit={formik.handleSubmit} className={updating ? "disabled" : ""}>
        <div className="row g-3 mb-3">
          <div className="col-md-4">
            <label className="mb-1">
              <strong>Preferred Learning Style</strong>
            </label>
            <select
              id="preferred_learning_style"
              name="preferred_learning_style"
              value={formik.values.preferred_learning_style}
              className="form-control"
              onChange={(e) => {
                const selectedSkill = e.target.value;
                formik.setFieldValue("preferred_learning_style", selectedSkill);
              }}
              {...formik.getFieldProps("preferred_learning_style")}
            >
              {LearningStyleOptions.map((skill) => {
                return <option value={skill.value}>{skill.label}</option>;
              })}
            </select>
            {formik.errors.preferred_learning_style ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.preferred_learning_style}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Preferred Learning Mode</strong>
            </label>
            <select
              id="preferred_learning_mode"
              name="preferred_learning_mode"
              value={formik.values.preferred_learning_mode}
              className="form-control"
              onChange={(e) => {
                const selectedSkill = e.target.value;
                formik.setFieldValue("preferred_learning_mode", selectedSkill);
              }}
              {...formik.getFieldProps("preferred_learning_mode")}
            >
              {LearningModeOptions.map((skill) => {
                return <option value={skill.value}>{skill.label}</option>;
              })}
            </select>
            {formik.errors.preferred_learning_mode ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.preferred_learning_mode}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>Are you comfortable with project-based learning?</strong>
            </label>
            <div className="d-flex align-items-center justify-content-between mb-3">
              {options.map((item, index) => {
                return (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-outline-grey flex-grow me-2 ${
                      formik?.values?.is_comfortable_with_project_based_learning ===
                      item?.value
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      formik.setFieldValue(
                        "is_comfortable_with_project_based_learning",
                        item?.value
                      );
                    }}
                  >
                    {item?.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className="row g-3 mb-3">
          <div className="col-md-4">
            <label className="mb-1">
              <strong>
                What are your primary motivations for joining this program?
              </strong>
            </label>

            <select
              id="primary_motivations_for_participation"
              name="primary_motivations_for_participation"
              value={formik.values.primary_motivations_for_participation}
              className="form-control"
              onChange={(e) => {
                const selectedState = e.target.value;
                formik.setFieldValue(
                  "primary_motivations_for_participation",
                  selectedState?.value
                );
                formik.setFieldTouched(
                  "primary_motivations_for_participation",
                  true
                );
              }}
              {...formik.getFieldProps("primary_motivations_for_participation")}
            >
              {Motivations.map((state) => {
                return <option value={state?.value}>{state?.label}</option>;
              })}
            </select>

            {formik.errors.primary_motivations_for_participation ? (
              <div className="text-danger mt-2 fs-12">
                {formik.errors.primary_motivations_for_participation}
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>
                What do you hope to achieve by the end of the program?
              </strong>
            </label>
            <textarea
              className="w-100 form-control"
              placeholder="Your answer"
              value={
                formik?.values
                  ?.what_do_you_hope_to_achieve_by_the_end_of_the_program
              }
              id="what_do_you_hope_to_achieve_by_the_end_of_the_program"
              name="what_do_you_hope_to_achieve_by_the_end_of_the_program"
              {...formik.getFieldProps(
                "what_do_you_hope_to_achieve_by_the_end_of_the_program"
              )}
              rows="3"
            />

            {formik.errors
              .what_do_you_hope_to_achieve_by_the_end_of_the_program ? (
              <div className="text-danger mt-2 fs-12">
                {
                  formik.errors
                    .what_do_you_hope_to_achieve_by_the_end_of_the_program
                }
              </div>
            ) : null}
          </div>

          <div className="col-md-4">
            <label className="mb-1">
              <strong>
                What topics or skills are you most excited to learn about?{" "}
              </strong>
            </label>
            <input
              id="what_topics_or_skills_are_you_most_excited_to_learn_about"
              name="what_topics_or_skills_are_you_most_excited_to_learn_about"
              value={
                formik.values
                  .what_topics_or_skills_are_you_most_excited_to_learn_about
              }
              placeholder="What topics or skills are you most excited to learn about?"
              className="form-control"
              {...formik.getFieldProps(
                "what_topics_or_skills_are_you_most_excited_to_learn_about"
              )}
            />

            {formik.errors
              .what_topics_or_skills_are_you_most_excited_to_learn_about ? (
              <div className="text-danger mt-2 fs-12">
                {
                  formik.errors
                    .what_topics_or_skills_are_you_most_excited_to_learn_about
                }
              </div>
            ) : null}
          </div>
        </div>

        <div className="d-flex justify-content-end">
        <button  onClick={() => setActiveTab("professional")} type="button" className="submit btn btn-outline-grey  me-2">
            Back
          </button>
          <button
            type="submit"
            className="submit btn btn-pigment-green"
            disabled={updating || !formik.dirty}
          >
            {updating ? (
              <span
                role="button"
                aria-hidden="true"
                className="spinner-border spinner-border-sm ms-2"
              ></span>
            ) : (
              "Save & Proceed"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Learning;

// const FormSchema = Yup.object().shape({
//   preferred_learning_style: Yup.string(),
//     // .required("Preferred Learning style is required"),

//   preferred_learning_mode: Yup.string(),
//     // .required("Preferred Learning Mode is required"),

//   is_comfortable_with_project_based_learning: Yup.boolean(),
//     // .required("This field is required"),

//   primary_motivations_for_participation: Yup.string(),
//     // .required("Primary motivation is required"),

//   what_do_you_hope_to_achieve_by_the_end_of_the_program: Yup.string(),
//     // .required("Expected Achievement is required"),

//   what_topics_or_skills_are_you_most_excited_to_learn_about: Yup.string()
//     // .required("Topic is required"),
// });

const FormSchema = Yup.object().shape({
  preferred_learning_style: Yup.string().nullable(),
  preferred_learning_mode: Yup.string().nullable(),
  is_comfortable_with_project_based_learning: Yup.boolean().nullable(),
  primary_motivations_for_participation: Yup.string().nullable(),
  what_do_you_hope_to_achieve_by_the_end_of_the_program: Yup.string().nullable(),
  what_topics_or_skills_are_you_most_excited_to_learn_about: Yup.string().nullable(),
});